import { z } from "zod"

import { TargetEnv } from "./environment.js"

export const TokensSchema = z.object({
  accessToken: z.string(),
  refreshToken: z.string().optional(),
})

const PendingStatusTokensSchema = z.object({
  status: z.literal("Pending"),
  tokens: z.never().optional(),
})

const SuccessStatusTokensSchema = z.object({
  status: z.literal("Success"),
  tokens: TokensSchema,
})

export const StatusTokensSchema = z.discriminatedUnion("status", [PendingStatusTokensSchema, SuccessStatusTokensSchema])

export const TokensResponseSchema = z.object({
  result: StatusTokensSchema,
})

export const RefreshTokenResponseSchema = z.object({
  result: z.object({
    tokens: TokensSchema,
  }),
})

export const AuthResponseSchema = z.object({
  result: z.object({
    authorizeUrl: z.string(),
    readKey: z.string(),
  }),
})

export const EnvTokensSchema = z.record(TargetEnv, TokensSchema.optional())

export type AuthResponse = z.infer<typeof AuthResponseSchema>
export type Tokens = z.infer<typeof TokensSchema>
export type TokensResponse = z.infer<typeof TokensResponseSchema>
export type RefreshTokenResponse = z.infer<typeof RefreshTokenResponseSchema>
export type EnvTokens = z.infer<typeof EnvTokensSchema>
